import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { Subtitle } from 'components/shared';
import { MoreInfo } from 'components/temoraryHomePage';
import { Products, SimplifiedLoans, StepsRepresent, Testimonials } from './shared';
import { HomePageTitle } from 'components/temoraryHomePage';

function Home() {
  return (
    <GeneralContainer>
      <Container>
        <HomePageTitle>Get An Instant Rate Quote in 2 Minutes or Less!</HomePageTitle>
        <Subtitle>Fix &amp; Flip and 30-Year Fixed Rental Loans at Market Competitive Rates</Subtitle>
      </Container>
      <Products />
      <SimplifiedLoans />
      <StepsRepresent />
      <MoreInfo />
      <Testimonials />
    </GeneralContainer>
  );
}

const Container = styled.div`
  padding: 0 10px;
  margin: 0 auto;

  ${media.between('medium', '991px')`
    max-width: 690px;
  `};
`;
const GeneralContainer = styled.div`
  padding: 0 10px;
  margin: 0 auto;
  background-color: var(--color-icon-background);
`;

export default Home;
